const theme = {
  token: {
    fontSize: 16,
    colorPrimary: '#7413BD',
    fontSizeIcon: 12,
    controlHeight: 36,
    colorText: "#333"
  },
};

export default theme;